import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
    currencySetupList,
    currencyViewDetail,
    deleteCurrency,
    AddCurrency,
    editCurrency,
} from "@/services/currency";

@Module({
    namespaced: true,
})
export default class currency extends VuexModule {
    // state

    fetchCurrencyList = [];
    fetchCurrencyView = [];
    fetchCurrencyEdit = [];
    isCurrency = true;

    // Action

    @Action
    public async fetchCurrencySetupList(payload) {
        try {
            const data = await currencySetupList(payload);
            this.context.commit("setCurrencyList", data.response);
            return data.response;
        } catch (err) {
            throw err;
        }
    }

    @Action
    public async fetchCurrencyDetail(id) {
        try {
            const data = await currencyViewDetail(id);
            this.context.commit("setCurrencyView", data);
            return data;
        } catch (err) {
            throw err;
        }
    }

    @Action
    public async currencyDeleteAction(payload) {
        try {
            const data = await deleteCurrency(payload);
            this.context.commit("removeCurrencyById", payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async AddCurrency(payload) {
        try {
            const data = await AddCurrency(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async currencyEditAction(payload) {
        try {
            const data = await editCurrency(payload);
            this.context.commit("setCurrencyEdit", data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    //Mutations

    @Mutation
    public setCurrencyList(data: any) {
        this.fetchCurrencyList = data;
    }

    @Mutation
    public removeCurrencyById(id: string) {
        this.fetchCurrencyList = this.fetchCurrencyList.filter(
            (item: any) => item._id !== id
        );
    }
    @Mutation
    public setCurrencyView(data: any) {
        this.fetchCurrencyView = data;
    }
    @Mutation
    public setCurrencyEdit(data: any) {
        this.fetchCurrencyEdit = data;
    }
    @Mutation
    public updateCurrency(data: any) {
        this.isCurrency = data;
    }
    //Getters
    get GetfetchCurrencyList() {
        return this.fetchCurrencyList;
    }
    get GetfetchCurrencyView() {
        return this.fetchCurrencyView;
    }
    get GetfetchCurrencyEdit() {
        return this.fetchCurrencyEdit;
    }
}
